import type { TrackingType } from "./types";

export interface TrackingFields {
  weight: boolean;
  reps: boolean;
  duration: boolean;
  distance: boolean;
  rir: boolean;
}

export interface SetInputValues {
  weightKg: string;
  reps: string;
  durationMin: string;
  distanceM: string;
  rpe: string;
  rir: string;
}

export interface SetPayload {
  weightKg?: number;
  reps?: number;
  durationSeconds?: number;
  distanceMeters?: number;
  rpe?: number;
  rir?: number;
}

export function getTrackingFields(trackingType: TrackingType): TrackingFields {
  return {
    weight: trackingType === "strength" || trackingType === "carry" || trackingType === "hold",
    reps: trackingType === "strength",
    duration: trackingType === "timed" || trackingType === "distance" || trackingType === "carry" || trackingType === "hold",
    distance: trackingType === "distance" || trackingType === "carry",
    rir: trackingType === "strength"
  };
}

function optionalNumber(value: string): number | undefined {
  if (!value.trim()) return undefined;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

export function buildSetPayload(trackingType: TrackingType, values: SetInputValues): SetPayload {
  const fields = getTrackingFields(trackingType);
  const payload: SetPayload = {};
  const rpe = optionalNumber(values.rpe);

  if (fields.weight) payload.weightKg = optionalNumber(values.weightKg);
  if (fields.reps) payload.reps = optionalNumber(values.reps);
  if (fields.duration) {
    const minutes = optionalNumber(values.durationMin);
    payload.durationSeconds = minutes === undefined ? undefined : Math.round(minutes * 60);
  }
  if (fields.distance) payload.distanceMeters = optionalNumber(values.distanceM);
  if (rpe !== undefined) payload.rpe = rpe;
  if (fields.rir) payload.rir = optionalNumber(values.rir);

  return Object.fromEntries(Object.entries(payload).filter(([, value]) => value !== undefined));
}
